import crud from '@/crud/index/index'
import resources from '../../resources'
import computed from './computed'

export default {
  computed,
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/index/resources/index.js